import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._handleScroll = this._handleScroll.bind(this)
    window.addEventListener("scroll", this._handleScroll, { passive: true })
    this._handleScroll() // 초기 상태 적용
  }

  disconnect() {
    window.removeEventListener("scroll", this._handleScroll)
  }

  _handleScroll() {
    if (window.scrollY > 50) {
      this.element.classList.add("scrolled")
    } else {
      this.element.classList.remove("scrolled")
    }
  }
}
